/**
 * @generated SignedSource<<e16675fa6ee38eaa1253308d7c836440>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ICAMinButikStatus = "ACTIVE" | "PENDING_LOGIN";
import { FragmentRefs } from "relay-runtime";
export type IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher$data = {
  readonly __typename: "ICAMinButikIntegration";
  readonly status: ICAMinButikStatus;
  readonly " $fragmentType": "IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher";
};
export type IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher$key = {
  readonly " $data"?: IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "ICAMinButikIntegration",
  "abstractKey": null
};

(node as any).hash = "d823010aabafb1c7c71fe81c9c3072c7";

export default node;
